// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu__kHEYHsxo5fJZ0"};